/** 진료·숨은보험금 CODEF 조회 시 고객 정보 처리 동의 */

export const HEALTH_DATA_CONSENT_VERSION = '2026-05-23'

const FALLBACK_ITEMS = {
  privacy: {
    id: 'privacy',
    docCode: 'HEALTH_INQUIRY_PRIVACY',
    versionLabel: HEALTH_DATA_CONSENT_VERSION,
    label: '개인정보 수집·이용 동의',
    summary: '간편인증·조회·분석을 위해 성명, 주민등록번호, 연락처 등을 수집·이용합니다.',
    required: true,
  },
  sensitive: {
    id: 'sensitive',
    docCode: 'HEALTH_INQUIRY_SENSITIVE',
    versionLabel: HEALTH_DATA_CONSENT_VERSION,
    label: '민감정보·고유식별정보 처리 동의',
    summary: '질병·진료 등 민감정보와 주민등록번호 등 고유식별정보를 조회·분석 목적으로 처리합니다.',
    required: true,
  },
  creditInfo: {
    id: 'creditInfo',
    docCode: 'HEALTH_INQUIRY_CREDIT',
    versionLabel: HEALTH_DATA_CONSENT_VERSION,
    label: '보험·의료비 자료 조회를 위한 개인(신용)정보 처리 동의',
    summary: '연말정산 간소화 등 경로의 보험·의료비 관련 정보를 조회·분석합니다.',
    required: true,
  },
  customerAuth: {
    id: 'customerAuth',
    docCode: 'HEALTH_INQUIRY_AGENT_CONFIRM',
    versionLabel: HEALTH_DATA_CONSENT_VERSION,
    label: '고객 동의 확인',
    summary: '해당 고객으로부터 정보 처리·간편인증 조회 동의를 받았음을 확인합니다.',
    required: true,
  },
}

export const HEALTH_DATA_CONSENT_VARIANTS = {
  'health-analysis': {
    serviceLabel: '국민건강보험 진료·투약 정보 조회',
    bundleVersion: HEALTH_DATA_CONSENT_VERSION,
    items: [FALLBACK_ITEMS.privacy, FALLBACK_ITEMS.sensitive, FALLBACK_ITEMS.customerAuth],
  },
  'health-analysis-customer': {
    serviceLabel: '국민건강보험 진료·투약 정보 조회',
    bundleVersion: HEALTH_DATA_CONSENT_VERSION,
    items: [FALLBACK_ITEMS.privacy, FALLBACK_ITEMS.sensitive],
  },
  'hidden-insurance': {
    serviceLabel: '보험·의료비 연말정산 간소화 자료 조회',
    bundleVersion: HEALTH_DATA_CONSENT_VERSION,
    items: [FALLBACK_ITEMS.privacy, FALLBACK_ITEMS.sensitive, FALLBACK_ITEMS.creditInfo, FALLBACK_ITEMS.customerAuth],
  },
}

export const FALLBACK_HEALTH_DATA_CONSENT_BUNDLES = Object.fromEntries(
  Object.entries(HEALTH_DATA_CONSENT_VARIANTS).map(([variant, config]) => [
    variant,
    { variant, bundleVersion: config.bundleVersion, items: config.items },
  ]),
)

export function createInitialHealthDataConsents(items) {
  const list = Array.isArray(items) ? items : []
  return Object.fromEntries(list.map((item) => [item.id, false]))
}

export function allHealthDataConsentsChecked(items, checked) {
  const list = Array.isArray(items) ? items : []
  return list.filter((item) => item.required !== false).every((item) => checked?.[item.id])
}

export function buildHealthDataConsentPayload(bundle, checked) {
  const items = bundle?.items ?? []
  return {
    dataProcessingConsentsAccepted: allHealthDataConsentsChecked(items, checked),
    dataProcessingConsentVersion: bundle?.bundleVersion || HEALTH_DATA_CONSENT_VERSION,
    consentItems: items.map((item) => ({
      docCode: item.docCode,
      versionLabel: item.versionLabel,
      accepted: !!checked?.[item.id],
    })),
  }
}
